import { Injectable } from '@angular/core';
import { from, Observable, throwError } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { ApiService } from '../../../core/services/api.service';
import { ReportType } from '../../../shared/enums/report-type.enum';

@Injectable()
export class TaxReportService extends ApiService {

    getOrdersDataWithReportsType(
        page: number = 1,
        limit: number = 100,
        searchParams?: any,
        orderField: string = '',
        orderDirection: string = '',
        companyId: string = '',
    ): Observable<any> {
        return this.request({
            method: 'GET',
            path: `tax-reports/get/orders-with-report-type`,
            query: {
                limit,
                page,
                dateTo: searchParams?.dateTo,
                dateFrom: searchParams?.dateFrom,
                reportType: searchParams?.reportType,
                orderField,
                orderDirection,
                customerIds: searchParams?.customerIds ? searchParams?.customerIds : '',
                companyId,
                isIndTax: searchParams.isIndTax
            }
        });
    }

    getTaxReportRepTool(
        page: number = 1,
        limit: number = 100,
        searchParams?: any,
        orderField: string = '',
        orderDirection: string = '',
        companyId: string = '',
    ): Observable<any> {
        return this.request({
            method: 'GET',
            path: `tax-reports/get/tax-reports-rep-tool`,
            query: {
                limit,
                page,
                dateTo: searchParams?.dateTo,
                dateFrom: searchParams?.dateFrom,
                reportType: searchParams?.reportType,
                orderField,
                orderDirection,
                customerIds: searchParams?.customerIds ? searchParams?.customerIds : '',
                companyId,
                isIndTax: searchParams?.isIndTax,
                country: searchParams?.country ? searchParams?.country : ''
            }
        });
    }

    getTotoalColumnOfOrdersDataWithReportsType(
        page: number = 1,
        limit: number = 100,
        q: string = '',
        searchParams?: any,
        orderField: string = '',
        orderDirection: string = '',
        includingCancelled: boolean = false,
        companyId: string = ''
    ): Observable<any> {
        return this.request({
            method: 'GET',
            path: `tax-reports/get/column-total-orders-with-report-type`,
            query: {
                // q: q,
                limit: limit,
                page: page,
                dateTo: searchParams?.dateTo,
                dateFrom: searchParams?.dateFrom,
                reportType: searchParams?.reportType,
                orderField: orderField,
                orderDirection: orderDirection,
                customerIds: searchParams?.customerIds ? searchParams?.customerIds : '',
                includingCancelled: includingCancelled ? includingCancelled : false,
                companyId: companyId
            }
        });
    }

    public generatePdf(body): any {
        this.requestPdf({
            path: `tax-reports/download/generate-pdf`,
            method: 'POST',
            body: body
        }).subscribe(res => {
            const fileURL = URL.createObjectURL(res);
            window.open(fileURL, '_blank');
        });
    }
    public generatePdfVat(body): any {
        this.requestPdf({
            path: `tax-reports/download/generate-pdf-indvat`,
            method: 'POST',
            body: body
        }).subscribe(res => {
            const fileURL = URL.createObjectURL(res);
            window.open(fileURL, '_blank');
        });
    }

    public generateXl(body): Observable<any> {
        return this.requestFile({
            path: `tax-reports/download/generate-xlsx`,
            method: 'POST',
            body: body
        }, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet').pipe(map(res => {
            const a = document.createElement('a')
            const objectUrl = URL.createObjectURL(res)
            a.href = objectUrl
            a.download = `${ReportType[body.reportType]}_Tax_report.xlsx`;
            a.click();
            URL.revokeObjectURL(objectUrl);
        }));
    }

    public generateXlIndVat(body): Observable<any> {
        return this.requestFile({
            path: `tax-reports/download/generate-xlsx-indvat`,
            method: 'POST',
            body: body
        }, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet').pipe(map(res => {
            const a = document.createElement('a')
            const objectUrl = URL.createObjectURL(res)
            a.href = objectUrl
            a.download = `${ReportType[body.reportType]}_Tax_report.xlsx`;
            a.click();
            URL.revokeObjectURL(objectUrl);
        }));
    }

    generateReport(body): Observable<any> {
        return this.request({
            method: 'POST',
            path: `tax-reports`,
            body: body
        });
    }

    getTaxReportById(id: number): Observable<any> {
        return this.request({
            path: `tax-reports/${id}`,
            method: 'GET',
        });
    }

    downloadTaxReport(id: number): Observable<any> {
        return this.request({
            path: `tax-reports/${id}`,
            method: 'POST',
        });
    }

    public downloadInvoice(orderId): Observable<any> {
        return this.requestPdf({
            path: `sale-orders/download`,
            method: 'POST',
            body: {
                invoiceId: orderId,
                type: 'PDF'
            }
        }).pipe(map(res => {
            const fileURL = URL.createObjectURL(res);
            window.open(fileURL, '_blank');
        }));
    }

    public downloadSalesInvoices(body): Observable<any> {
        return this.requestFile({
            path: `tax-reports/download/download_sales_invoices`,
            method: 'POST',
            body: body
        }).pipe(map(res => {
            const a = document.createElement('a')
            const objectUrl = URL.createObjectURL(res)
            a.href = objectUrl
            a.download = `sale_invoices_${body.dateFrom.toString()}_${body.dateTo.toString()}.zip`;
            a.click();
            URL.revokeObjectURL(objectUrl);
        }));

    }

    public downloadSalesInvoicesIndVat(body): Observable<any> {
        return this.requestFile({
            path: `tax-reports/download/download_sales_invoices_indvat`,
            method: 'POST',
            body: body
        }).pipe(map(res => {
            const a = document.createElement('a')
            const objectUrl = URL.createObjectURL(res)
            a.href = objectUrl
            a.download = `sale_invoices_${body.dateFrom.toString()}_${body.dateTo.toString()}.zip`;
            a.click();
            URL.revokeObjectURL(objectUrl);
        }));

    }

    getReportsDataWithReportsType(
        page: number = 1,
        limit: number = 100,
        type: number = ReportType.OSS,
        fromMonth?: string,
        fromYear?: string,
        toMonth?: string,
        toYear?: string,
        partnerId?: any,
        customerId?: any,
        countryCode?: string[]
    ): Observable<any> {
        const query: any = {
            limit,
            page,
            type,
        };

        fromMonth && (query.fromMonth = fromMonth);
        fromYear && (query.fromYear = fromYear);
        toMonth && (query.toMonth = toMonth);
        toYear && (query.toYear = toYear);

        if (partnerId?.length) query.partnerId = partnerId;
        if (customerId?.length) query.customerId = customerId;
        if (countryCode?.length) query.countryCode = countryCode;

        return this.request({
            method: 'GET',
            path: `reported-tax-reports`,
            query
        });
    }

    downloadReportedTaxReport(report: any, reportType: ReportType): Observable<any> {
        return this.request({
            path: `reported-tax-reports/download/${report.id}`,
            method: 'GET',
        }).pipe(
            switchMap((res: any) => {
                if (!res || !res.file) {
                    return throwError(() => new Error('No file URL returned from server'));
                }
                return from(fetch(res.file).then(response => {
                    if (!response.ok) throw new Error(`Failed to fetch file: ${response.statusText || response.status}`);
                    return response.blob();
                }));
            }),
            map((blob: Blob) => {
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;

                const date = new Date(report.year, report.month - 1);
                const timeLine = report.isQuarterly ? report.quarter : date.toLocaleString('default', { month: 'long' });
                const fileName = `${ReportType[reportType]}_TaxReport_${timeLine}_${report.year}_${report.customerName}.xlsx`;

                a.setAttribute('download', fileName);
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
            }),
        );
    }

    public removeReportedTaxReport(id: number): Observable<any> {
        return this.request({
            path: `reported-tax-reports/${id}`,
            method: 'DELETE',
        });
    }

    //#endregion
}
